import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { PaginationRequest } from "src/app/models/common.request";
import { IDrugCompany } from "./idrug-company";


@Injectable({ providedIn: 'root' })
export class DrugCompanyService {

    private _drugCompany: BehaviorSubject<IDrugCompany | null> = new BehaviorSubject<IDrugCompany | null>(null);
    private _drugcompanies: BehaviorSubject<IDrugCompany[]> = new BehaviorSubject<IDrugCompany[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get drugCompany$(): Observable<IDrugCompany | null> {
        return this._drugCompany.asObservable();
    }

    get drugcompanies$(): Observable<IDrugCompany[]> {
        return this._drugcompanies.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }

    getAllDrugComapany(drugCompanyData: PaginationRequest): Observable<BaseRespone<{ pagination: PaginationResult; drugCompanyDetails: IDrugCompany[] }>> {
        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; drugCompanyDetails: IDrugCompany[] }>>(`${environment.baseURl}/Drug/CompanyList`, drugCompanyData).pipe(
            tap((response) => {
                this._pagination.next(response.result.pagination);
                this._drugcompanies.next(response.result.drugCompanyDetails);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    createDrugCompany(drugcompany: IDrugCompany): Observable<BaseRespone<IDrugCompany>> {
        return this._httpClient.post<BaseRespone<IDrugCompany>>(`${environment.baseURl}/Drug/DrugCompany`, drugcompany)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newdrugcompany) => {
                    // Return the new patients
                    return newdrugcompany;
                })
            )
    }

    // deleteGenericContetnt(id: number): Observable<BaseRespone<boolean>> {
    //     return this.genericContetnts$.pipe(
    //         take(1),
    //         switchMap(patient =>
    //             this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/Drug/GenericContent/${id}`).pipe(
    //                 map((deletedResponse) => {
    //                     if (deletedResponse.result) {
    //                         const GenericContetnt = patient.filter(item => item.id !== id);
    //                         this._genericContents.next(GenericContetnt);
    //                     }
    //                     return deletedResponse;
    //                 })
    //             )
    //         ), catchError((error) => {
    //             return of(error.error);
    //         })
    //     );
    // }

    updateDrugCompany(drugComapany: IDrugCompany): Observable<BaseRespone<IDrugCompany>> {
        return this.drugcompanies$.pipe(
            take(1),
            switchMap(drugComapanies => this._httpClient.put<BaseRespone<IDrugCompany>>(`${environment.baseURl}/Drug/DrugCompany`, drugComapany).pipe(
                map((updated: BaseRespone<IDrugCompany>) => {

                    // Find the index of the updated product
                    const index = drugComapanies.findIndex(item => item.id === drugComapany.id);

                    // Update the product
                    drugComapanies[index] = drugComapany;

                    // Update the products
                    this._drugcompanies.next(drugComapanies);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

}